import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {


}



// WEBPACK FOOTER //
// /Users/mac-jeremy/Projets/fairepart/src/app/app.component.ts